<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()
const router = useRouter()

const showBackButton = computed(() => route.meta.showBackButton as boolean)
const headerMode = computed(() => (route.meta.headerMode as string) || 'icon')
const title = computed(() => route.meta.title as string)

const handleBack = () => {
  router.back()
}
</script>

<template>
  <div class="tw-w-full tw-max-h-[72px] tw-bg-primary2 tw-flex tw-items-center tw-justify-center">
    <!-- Back Button -->
    <div v-if="showBackButton" class="tw-absolute tw-left-4">
      <v-btn
        style="box-shadow: none; background-color: transparent; color: white"
        icon="mdi-arrow-left"
        density="compact"
        size="x-large"
        @click="handleBack"
      ></v-btn>
    </div>

    <!-- Header Content -->
    <div v-if="headerMode === 'icon'" class="tw-py-3">
      <img src="/images/logo/logo_xpress_clinic.png" alt="Aura Xpress Clinic" class="tw-h-[52px] tw-object-contain" />
    </div>
    <div v-else-if="headerMode === 'title'" class="tw-py-6">
      <h1 class="tw-text-white tw-text-xl tw-font-semibold">{{ title }}</h1>
    </div>
  </div>
</template>
